import { render, staticRenderFns } from "./ReconciliationsComponent.vue?vue&type=template&id=24c6d22e&"
import script from "./ReconciliationsComponent.vue?vue&type=script&lang=js&"
export * from "./ReconciliationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports